import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { SharedataService } from '../service/sharedata.service';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],

  animations: [
    trigger('formFieldsAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
      ])
    ])
  ]


})
export class SignupComponent extends BaseCtl implements OnInit {
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private shareService: SharedataService,
    private router: Router
  ) {
    super('', locator, route);

    let _self = this;
    locator.config.getProperty('endpoint.login').then((property: string) => {
      this.initApiEndpoint(property);
    });

    _self.locator.config.getProperty("CONTEXT_PATH").then((property: string) => {
      _self.keySuffix = property + "-";

      locator.getPathVariable(route, function (params: any) {
        _self.authKey = params["authKey"];
        if (_self.authKey) {
          localStorage.setItem(_self.keySuffix + 'cdAuthkey', _self.authKey);
          let [orgId, appId] = _self.authKey.toString().split(".");
          _self.orgId = orgId;
          _self.appId = appId;
        } else {
          let cdAuthkey = localStorage.getItem(_self.keySuffix + 'cdAuthkey');
          if (cdAuthkey !== null && cdAuthkey !== 'null') {
            let [orgId, appId] = cdAuthkey.toString().split(".");
            _self.orgId = orgId;
            _self.appId = appId;
          } else {
            localStorage.setItem(_self.keySuffix + 'cdAuthkey', "-1");
          }
        }

      });
    });


  }

  public authKey: string = "";
  public appId: any = 0;
  public orgId: any = 0;
  public keySuffix: any;
  public applicationLogo: any = 0;
  public orgLogo: any = 0;
  public appName: any;
  public orgName: any
  isLogin = false;

  override ngOnInit(): void {
    let _self = this;
    _self.locator.config
      .getProperty('DEFAULT_ORGNIZATION_ID')
      .then((property: string) => {
        _self.GetApplicationDetails(_self.appId);
        _self.getOrgDetails(_self.orgId);
        _self.form.data['orgId'] = property;
        _self.form.data['roleId'] = _self.shareService.getData1();

      });
  }

  override populateForm(form: any, data: any) {
    form.data.firstName = data.firstName;
    form.data.lastName = data.lastName;
    form.data.login = data.login;
    form.data.password = data.password;
  }

  /***
   * SignUp User Application with orgId and AppId 
   */


  emailExists = true;
  email:any;
 
  checkEmail(){

    if(this.form.data['loginId'])
      this.email=this.form.data['loginId']
    // console.log(this.form.data['loginId'])
    // console.log( this.email)
    // var _self =this;
    // _self.locator.config.getProperty('endpoint.login').then((property: string) => {
    //   let url = property + "/signin";
    //     this.locator.http.post(url, _self.form.data,function (res: any, error: boolean) {
    //       //   if (error) {
    //       // alert("Server Error:" + error);
    //       //     return;
    //       //   }

    //         _self.form.message = '';
    //         _self.form.inputerror = {};
    //      console.log(res.success)

    
    
       

    //       });
    // }) 
  
  
  
  
    var _self = this;
    _self.locator.config
      .getProperty('endpoint.login')
      .then((property: string) => {
        let url = property + '/isUserExistSso';

        console.log(url)
        this.locator.http.post(
          url,
          this.form.data,
          function (res: any, error: any) {
            console.log('response', res);
            _self.form.message = '';
            _self.form.inputerror = {};
            if (error) {
              _self.form.error = true;
              _self.form.message = 'Error: ' + error;
            }



            if(res.success)
              {
               _self.emailExists=true;  
                 
          _self.form.message="You already Register"
               setTimeout(() => {
                 _self.router.navigate(['/login']); 
                      }, 1500); 
              }else{
               _self.emailExists=false;
               _self.form.data['loginId']=_self.email;
              }
         

            // if (res.success) {
            //   _self.isLogin = true;
            // } else {
            //   _self.form.error = !res.success;
            //   _self.form.message = res.result.message;
            //   _self.form.inputerror = res.result.inputerror;
            // }
          }
        );
      });

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  } 
  

  signup() {
    var _self = this;
    _self.locator.config
      .getProperty('endpoint.login')
      .then((property: string) => {
        let url = property + '/signupUserApp';
        _self.form.data['orgId'] = _self.locator.config.get(
          'DEFAULT_ORGNIZATION_ID'
        );
        _self.form.data['roleName'] = _self.locator.config.get('DEFAULT_ROLE');

        _self.form.message = '';
        _self.form.inputerror = {};

        this.locator.http.post(
          url,
          this.form.data,
          function (res: any, error: any) {
            if (error) {
              alert("Server Error:" + error);
              return;
            }

            if (res.success) {
              _self.isLogin = true;
              _self.emailExists = false;
            } else {
              _self.form.error = !res.success;
              _self.form.message = res.result.message;
              _self.form.inputerror = res.result.inputerror;
             _self.emailExists = true;
           setTimeout(() => {
            _self.router.navigate(['/login']); // Redirect to login page if email exists
            }, 2000); 
            }
          }
        );
      });
  }

  /**
   * Get Application Details
   * @param id 
   * @returns 
   */
  GetApplicationDetails(id: any) {
    var _self = this;
    if (!id || id == -1) {
      return;
    }
    _self.locator.config.getProperty("endpoint.application").then((property: string) => {
      let url = property + "/public/applicationDetails/" + id;
      this.locator.http.get(url, function (res: any, error: any) {
        if (error) {
          console.log("Server Error:" + error);
          return;
        }
        if (res.success) {
          _self.applicationLogo = res.result.data['logo'];
          _self.appName = res.result.data['name'];
          _self.form.data['roleId'] = res.result.data?.roleId;
        }
      });

    });
  }


  /**
   * Get Org Details
   */
  getOrgDetails(id: any) {
    var _self = this;
    if (!id || id == -1) {
      return;
    }
    _self.locator.config.getProperty("endpoint.orgnization").then((property: string) => {
      let url = property + "/public/orgDetails/" + id;
      this.locator.http.get(url, function (res: any, error: any) {
        if (error) {
          console.log("Server Error:" + error);
          return;
        }
        if (res.success) {
          _self.orgLogo = res.result.data['logoId'];
          _self.orgName = res.result.data['name'];
        }
      });
    });
  }


  //------show Password---------
  showPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
